import { render, staticRenderFns } from "./HandymanReport.vue?vue&type=template&id=5bf8db91"
import script from "./HandymanReport.vue?vue&type=script&lang=js"
export * from "./HandymanReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports